import { toast } from "react-toastify";
import ApiService from "../../../services/apiService";
import Add from "../../table/Add"
import { useNavigate } from "react-router-dom";

const AddProject = () =>{
    const navigate = useNavigate();

      const onSubmit = async(data:any)=>{
         try{
           const response = await ApiService.axiosApi(`/projectsettings/addproject`,{
            method: "POST",
            data: data
           })
           if(response.success){
            toast.success("project added success fully")
            navigate(-1)
           }else{
             console.log(response.message|| response.status ||"unable  to add project")
           }
        }catch(error){
             console.log(error)
        }
      }
  
     return(
        <>
          <Add
             title = {"Add Project"}
             parentTitle = {"Projects"}
             onSubmit = {onSubmit}

             fields = {[
                 {
                  name : "ProjectName",
                  label  :"Project Name",
                  type: "text",
                  validation :  { required: "Project Name is required" }
                 },
                 {
                  name: "No_Of_Door",
                  label: "Number Of Doors", 
                  type: "text",
                  validation : {required : "Value is required"}
                 },
                 {
                  name: "No_Of_WaterMeter",
                  label: "Number Of WaterMeters", 
                  type: "text",
                  validation : {required : "WaterMeters is required"}
                 },
                 {
                  name: "No_Of_PressureValve",
                  label: "Number Of PressureValve", 
                  type: "text",                       
                  validation : {required : "Pressure is required"}
                 },
                 {
                  name: "TotalValves",
                  label: "Number Of TotalValves", 
                  type: "text",
                  validation : {required : "TotalValve is required"}
                 }
             ]}
            />
          
        </>
     )
}

export default AddProject;